<template>
    <div class="appointment">
        <pdfs class="m-b-20 pdfs"></pdfs>
        <div class="handwriting" @click="viewPage()">确认签名</div>
        <!-- <handwriting class="handwriting" @func="getMsgFormSon"></handwriting> -->
    </div>
</template>
<script>
    // import pdfs from '@/components/pdfs.vue'
    import pdfs from './viewPdfs.vue'
    export default {
    components: {
        pdfs
    },
    data () {
      return {
        phone: this.$route.query.phone,
        name: this.$route.query.name
      }
    },
    created(){
        this.$loca.setItem('routeItem', this.$route.path);
    },
    methods: {
        viewPage(){
            this.$router.push({path:'/viewHandwriting', 
            query:{
                item: this.$route.query.item,
                phone: this.phone,
                name: this.name
            }});
        }
    }
}
</script>

<style lang="scss" scoped>
.appointment{
    position: relative;
    width: 100vw;
    height: 100%;
    .handwriting{
        width: 100vw;
        height: 100px;
        position: fixed;    
        bottom: 0;
        z-index: 999;
        color: #ffffff;
        line-height: 100px;
        background: #00B7EE;
        text-align: center;
        font-size: 32px;
    }
    .pdfs{
        width: 100vw;
        height: calc(100% - 100px);
        // overflow-y: scroll;
    }
}
</style>

